// JavaScript to sync range and number inputs
const hourlyWageRange = document.getElementById('hourly-wage');
const hourlyWageNumber = document.getElementById('hourly-wage-number');
const numEmployeesRange = document.getElementById('num-employees');
const numEmployeesNumber = document.getElementById('num-employees-number');
const hoursPerDayRange = document.getElementById('hours-per-day');
const hoursPerDayNumber = document.getElementById('hours-per-day-number');

const rangeInputs = document.querySelectorAll('input[type="range"]');
const numberInputs = document.querySelectorAll('input[type="number"]');

function updateSliderBackground(input) {
    const value = (input.value - input.min) / (input.max - input.min) * 100;
    input.style.setProperty('--value', `${value}%`);
}

// Run on page load
rangeInputs.forEach(input => {
    updateSliderBackground(input);
});

// Update on input change (range sliders)
rangeInputs.forEach(input => {
    input.addEventListener('input', function() {
        updateSliderBackground(this);
    });
});

// Update on input change (number inputs)
numberInputs.forEach(input => {
    input.addEventListener('input', function() {
        const associatedRange = document.querySelector(`#${this.dataset.rangeId}`);
        associatedRange.value = this.value;
        updateSliderBackground(associatedRange);
    });
});

function updateBreakdown() {
    const currentVacuumSelect = document.getElementById('current-vacuum');
    const newVacuumSelect = document.getElementById('new-vacuum');

    const currentVacuum = parseFloat(currentVacuumSelect.value);
    const newVacuum = parseFloat(newVacuumSelect.value);
    const hourlyWage = parseFloat(hourlyWageNumber.value);
    const numEmployees = parseFloat(numEmployeesNumber.value);
    const hoursPerDay = parseFloat(hoursPerDayNumber.value);

    const currentVacuumTitle = currentVacuumSelect.options[currentVacuumSelect.selectedIndex].text;
    const newVacuumTitle = newVacuumSelect.options[newVacuumSelect.selectedIndex].text;

    const currentVacuumRate = currentVacuum;
    const newVacuumRate = newVacuum;

    const currentVacuumLabor = (hourlyWage * hoursPerDay * numEmployees).toFixed(2);
    const newVacuumLabor = currentVacuumLabor;

    const currentVacuumCost = (currentVacuumLabor * 240).toFixed(2);
    const newVacuumCost = (newVacuumLabor * 240).toFixed(2);

    document.getElementById('currentVacuumRate').innerText = `${currentVacuumRate} sq. ft/hr (${currentVacuumTitle})`;
    document.getElementById('newVacuumRate').innerText = `${newVacuumRate} sq. ft/hr (${newVacuumTitle})`;
    document.getElementById('currentVacuumLabor').innerText = formatCurrency(currentVacuumLabor);
    document.getElementById('newVacuumLabor').innerText = formatCurrency(newVacuumLabor);
    document.getElementById('currentVacuumCost').innerText = formatCurrency(currentVacuumCost);
    document.getElementById('newVacuumCost').innerText = formatCurrency(newVacuumCost);
}

function formatCurrency(value) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(value);
}

function syncInput(rangeInput, numberInput) {
    rangeInput.addEventListener('input', () => {
        numberInput.value = rangeInput.value;
        calculateSavings();
    });
    numberInput.addEventListener('input', () => {
        rangeInput.value = numberInput.value;
        calculateSavings();
    });
}

syncInput(hourlyWageRange, hourlyWageNumber);
syncInput(numEmployeesRange, numEmployeesNumber);
syncInput(hoursPerDayRange, hoursPerDayNumber);

const currentVacuumSelect = document.getElementById('current-vacuum');
const newVacuumSelect = document.getElementById('new-vacuum');

currentVacuumSelect.addEventListener('change', calculateSavings);
newVacuumSelect.addEventListener('change', calculateSavings);

document.getElementById('breakdownBtn').addEventListener('click', function() {
    const breakdown = document.getElementById('breakdown');
    if (breakdown.style.display === "none") {
        breakdown.style.display = "block";
        updateBreakdown();
    } else {
        breakdown.style.display = "none";
    }
});

let yearlyDays = 260; // Default to yearly

function updateYearlyDays(days, buttonId) {
    yearlyDays = days;
    setActiveButton(buttonId); // Set the active class on the clicked button
    calculateSavings(); // Recalculate savings with the updated yearlyDays
}

document.getElementById('daily-savings').addEventListener('click', () => updateYearlyDays(1, 'daily-savings'));
document.getElementById('weekly-savings').addEventListener('click', () => updateYearlyDays(5, 'weekly-savings'));
document.getElementById('monthly-savings').addEventListener('click', () => updateYearlyDays(20, 'monthly-savings'));
document.getElementById('yearly-savings').addEventListener('click', () => updateYearlyDays(260, 'yearly-savings'));

function setActiveButton(buttonId) {
    const buttons = document.querySelectorAll('.button-group button');
    buttons.forEach(button => button.classList.remove('active')); // Remove active class from all buttons
    document.getElementById(buttonId).classList.add('active'); // Add active class to the clicked button
}

function calculateSavings() {
    const currentVacuum = parseFloat(currentVacuumSelect.value);
    const newVacuum = parseFloat(newVacuumSelect.value);
    const hourlyWage = parseFloat(hourlyWageNumber.value);
    const numEmployees = parseFloat(numEmployeesNumber.value);
    const hoursPerDay = parseFloat(hoursPerDayNumber.value);

    const sqFtDifference = newVacuum - currentVacuum;
    const cleaningRate = (hourlyWage * hoursPerDay);
    const laborCost = cleaningRate * numEmployees * yearlyDays;
    const cleaningSpent = ((sqFtDifference / currentVacuum) * hourlyWage * hoursPerDay * numEmployees * yearlyDays).toFixed(2);
    let costSavings = ((sqFtDifference / currentVacuum) * hourlyWage * hoursPerDay *  yearlyDays * numEmployees).toFixed(2);

    // Ensure that negative savings show as $0
    // if (costSavings < 0) {
    //     document.getElementById('savingsDisplay').innerText = "*Total Savings: " + formatCurrency(0);
    // } else {
    //     document.getElementById('savingsDisplay').innerText = "*Total Savings: " + formatCurrency(costSavings);
    // }

    document.getElementById('savingsDisplay').innerText = "*Total Savings: " + formatCurrency(costSavings);

    updateBreakdown();

}

// Initial calculation
calculateSavings();